import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SocketService } from '../../../../common/services/socket.service';
import { Subscription } from 'rxjs';
import {
  NbGlobalPhysicalPosition,
  NbPopoverDirective,
  NbToastrService,
} from '@nebular/theme';
import { NotificationItemType } from '../../../../pages/notifications/models/notification.model';
import { Router } from '@angular/router';
import { timeAgo } from '../../../../common/utils/date';
import { SystemNotificationsService } from '../../../../pages/notifications/system-notifications.service';
import { TabNotificationSoundService } from '../../../../common/services/tab-notification-sound.service';

@Component({
  selector: 'ngx-header-system-notifications',
  templateUrl: './header-system-notifications.component.html',
  styleUrls: ['./header-system-notifications.component.scss'],
  providers: [SystemNotificationsService],
})
export class HeaderSystemNotificationsComponent implements OnInit, OnDestroy {
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  private clickSound = new Audio('assets/sounds/ding-notification.wav');

  count: number = 0;
  notifications: (NotificationItemType & { time: string })[] = [];

  private notifSubscription!: Subscription;

  constructor(
    private systemNotificationsService: SystemNotificationsService,
    private socketService: SocketService,
    private toastrService: NbToastrService,
    private router: Router,
    private tabNotificationSound: TabNotificationSoundService,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
    this.subscribeNotification();
    this.loadNotificationCount();
  }

  loadToast(title: string, message: string) {
    this.toastrService.show(message, title, {
      duration: 3000, // 🚫 no auto-dismiss
      destroyByClick: true,
      status: 'info',
      // hasIcon: true,
      limit: 5,
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
    });
  }

  private playSound() {
    if (this.tabNotificationSound.isMuted) return;

    this.clickSound.currentTime = 0;
    this.clickSound.play().catch(() => {});
  }

  subscribeNotification() {
    this.notifSubscription = this.socketService
      .onSystemNotification()
      .subscribe((res) => {
        const notification =
          typeof res === 'string'
            ? (JSON.parse(res) as NotificationItemType)
            : res;
        this.notifications.unshift({
          ...notification,
          id: notification.id || notification._id,
          time: timeAgo(notification.createdAt),
        });
        this.count = this.count + 1;
        this.loadToast(notification.title, notification.message);
        this.playSound();
      });
  }

  private loadNotifications() {
    this.systemNotificationsService
      .list({
        page: 1,
        sort: { createdAt: 'DESC' },
      })
      .subscribe({
        next: (res) => {
          this.notifications = (res.data?.items || []).map((i) => ({
            ...i,
            time: timeAgo(i.createdAt),
          }));
        },
        error: () => {
          this.notifications = [];
        },
      });
  }

  private loadNotificationCount() {
    this.systemNotificationsService.unreadCount().subscribe({
      next: (res) => {
        this.count = res.data.unreadCount;
      },
      error: () => {
        this.count = 0;
      },
    });
  }

  handleNotificationAction(item: NotificationItemType) {
    this.systemNotificationsService.update(item.id, {}).subscribe({
      next: (res) => {
        const data = res.data;
        this.count = this.count - 1;
        const index = this.notifications.findIndex(
          (notif) => notif.id === item.id
        );

        this.notifications[index] = { ...data, time: timeAgo(data.createdAt) };
      },
      error: () => {},
    });

    // this.router.navigate([`/pages/orders/view/${item.metadata.orderId}`]);
    this.closePopover();
  }

  handleReadAll() {
    // this.systemNotificationsService.update(item.id, {}).subscribe(() => {
    //   this.count = this.count - 1;
    // });
    // this.popover.hide();
  }

  closePopover() {
    this.popover.hide();
  }

  ngOnDestroy(): void {
    this.notifSubscription.unsubscribe();
  }
}
